import React from 'react'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'

import Button from 'components/Button'
import getProductUrl from 'helpers/getProductUrl'
import CartTrash from 'components/Icons/CartTrash'
import CartPlusIcon from 'components/Icons/CartPlusIcon'
import CartMinusIcon from 'components/Icons/CartMinusIcon'
import { useQuantityControls } from 'hooks/useQuantityControls'
import { useSelectedColor } from '../../../store/SelectedColorProvider'

const HeaderCartItem = ({ product }) => {
  const { quantity, handleIncrease, handleDecrease, handleDelete } =
    useQuantityControls(product)
  const { getProductColor } = useSelectedColor()

  const handleRemove = () => {
    handleDelete().then(() => {
      toast.info('პროდუქტი წაიშალა კალათიდან')
    })
  }

  const productColor = getProductColor(product.sku)
  const coloredImage = product.product_images?.find(
    img => img.color_name === productColor
  )
  const imageUrl = coloredImage?.url || product.image

  return (
    <div
      to={getProductUrl(product.slug)}
      className="flex items-center gap-3 py-2 border-b border-slate-100 last:border-b-0"
    >
      <div className="w-16 h-16 flex-shrink-0">
        <img
          src={imageUrl}
          alt={product.name}
          className="w-full h-full object-contain"
        />
      </div>
      <div className="flex-grow min-w-0">
        <Link to={getProductUrl(product.slug)}>
          <h3 className="text-sm font-medium text-slate-700 truncate hover:text-[#ff2337]">
            {product.name}{' '}
            {productColor ? (
              <span className="capitalize font-bold">({productColor})</span>
            ) : (
              ''
            )}
          </h3>
        </Link>
        <div className="flex items-center gap-2 mt-1 text-slate-400 ">
          <div className="flex items-center">
            <button
              onClick={handleDecrease}
              className="hover:scale-110 active:scale-95 transition-all duration-150 cursor-pointer hover:text-[#e63946]"
            >
              <CartMinusIcon width="18" height="18" />
            </button>
            <span className="w-6 text-center font-bold text-slate-700 text-xs mb-1">
              {quantity}
            </span>
            <button
              onClick={handleIncrease}
              className="hover:scale-110 active:scale-95 transition-all duration-150 cursor-pointer hover:text-[#e63946]"
            >
              <CartPlusIcon width="18" height="18" />
            </button>
          </div>
          <p className="text-sm font-bold text-slate-700 mb-1">
            {product.price * quantity} ₾
          </p>
          <Button className="mr-1 ml-auto" onClick={handleRemove}>
            <CartTrash color="#ff2337" height={15} width={15} />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default HeaderCartItem
